import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const Counter = ({ end, suffix = "", prefix = "", duration = 2.2 }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [val, setVal] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const start = performance.now();
        let raf;
        const tick = (now) => {
            const p = Math.min((now - start) / (duration * 1000), 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(end * eased);
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, end, duration]);

    return (
        <span ref={ref}>
            {prefix}
            {Math.round(val).toLocaleString("en-IN")}
            {suffix}
        </span>
    );
};
